import { Button, Card, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { WarningIconWithTooltip } from '../../../common-client2/src/components';
import { SearchableSelect } from '../../../common/components/UI/Select';
import { EXCLUDED_HYPERFIND_IDS, WARNING_TYPES } from '../../constants';

const DynamicHyperfindForm = (props) => {
    const createUI = () => {
        const { hyperFindList, adminSettingList, configs, isFullyEditable, settingSelected, t } = props;

        const unarchivedSettings = adminSettingList.filter(x => !x.isArchive);
        let filteredAdminSettingList = unarchivedSettings;
        if (configs.length > 0) {
            let conf = configs[0];
            let firstSelectedAdminSetting = unarchivedSettings.find(x => x.id === conf.adminSettingsId);
            if (firstSelectedAdminSetting) {
                const approval = firstSelectedAdminSetting.autoApproval;
                const isKeepEmployeeWorkRule = firstSelectedAdminSetting.isKeepEmployeeWorkRule;
                const isAllowMultipleRequests = firstSelectedAdminSetting.isAllowMultipleRequests;
                filteredAdminSettingList = filteredAdminSettingList.filter(x => x.autoApproval === approval &&
                    x.isKeepEmployeeWorkRule === isKeepEmployeeWorkRule &&
                    x.isAllowMultipleRequests === isAllowMultipleRequests);
            }
        }

        const includedHyperfindOptions = hyperFindList.filter(x => !EXCLUDED_HYPERFIND_IDS.includes(x.value));
        return configs.map((el, i) => {
            const selectedAdminSetting = adminSettingList.find(setting => setting.id === el.adminSettingsId) ?? {};
            const isFailingHyperfindExecution = el.warnings?.includes(WARNING_TYPES.FAILING_HYPERFIND_EXECUTION);
            const warning = el.warnings?.map(x => t(`manager.managerWarnings.${x}`)) ?? [];

            return (
                <Card key={i} style={{ 'padding': '15px', 'marginBottom': '15px', 'overflow': 'visible' }}>
                    <Grid container>
                        <Grid item xs={9}>
                            <Typography variant="h6">Rule Set {i + 1}</Typography>
                        </Grid>
                        <Grid item xs={3} justifyContent={'flex-end'} style={{ display: 'flex' }}>
                            <Button disabled={!isFullyEditable} variant="outlined" color="primary" onClick={() => removeClick(i)} size="small" startIcon={<DeleteIcon />}>Remove</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <div>
                                        <div className="labelWrapper"><span className="label">{t('manager.sidePanel.people')}</span></div>
                                        <SearchableSelect
                                            options={includedHyperfindOptions}
                                            value={includedHyperfindOptions.find((option) => option.value === el.hyperfindId) ?? null}
                                            onChange={(option) => handleChange(i, 'hyperfindId', option?.value ?? '')}
                                            placeholder={t('manager.sidePanel.selectPeople')}
                                            disabled={!isFullyEditable && !(isFailingHyperfindExecution)}
                                            error={isDuplicate(el)}
                                        />
                                    </div>
                                </div>
                                {isFailingHyperfindExecution && (
                                    <div style={{ alignItems: 'center', display: 'flex', marginBottom: '15px', marginLeft: '10px' }}>
                                        <WarningIconWithTooltip tooltipWarnings={warning} />
                                    </div>
                                )}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div>
                                <div className="labelWrapper"><span className="label">{t('manager.sidePanel.requestSetup')}</span></div>
                                <SearchableSelect
                                    options={i === 0 ? unarchivedSettings : filteredAdminSettingList}
                                    value={(i === 0 ? unarchivedSettings : filteredAdminSettingList).find((option) => option.id === el.adminSettingsId) ?? null}
                                    onChange={(option) => handleChange(i, 'adminSettingsId', option?.id ?? '')}
                                    placeholder={t('manager.sidePanel.selectRequestSetup')}
                                    disabled={!isFullyEditable}
                                    getOptionLabel={(option) => option?.label ?? ''}
                                    isOptionEqualToValue={(option, selected) => option.id === selected.id}
                                />
                            </div>
                       </Grid>
                        {
                            selectedAdminSetting && selectedAdminSetting.enablePartialShifts && [0, 1, 2, 3].includes(selectedAdminSetting.actionType) ? <Grid item xs={12}>
                                <Typography style={{ color: '#878787', fontSize: 12, }}>{'Enable partial shift'}</Typography>
                                <FormControlLabel
                                    control={<Switch disabled={!isFullyEditable} size="small" onChange={(event, value) => handleChange(i, 'enablePartialShifts', value)} checked={el.enablePartialShifts} color="primary" />}
                                    label={<Typography style={{ color: '#878787', fontSize: 10, }}>{el.enablePartialShifts ? 'Partial shift enabled' : 'Partial shift disabled'}</Typography>}
                                />
                            </Grid> : null
                        }
                    </Grid>
                </Card>
            )
        })
    }

    const handleChange = (i, field, value) => {
        let configs = [...props.configs];
        const oldAdminSettingsId = configs[i]?.adminSettingsId;
        configs[i] = {
            ...configs[i],
            [field]: value
        }
        
        if (field == 'adminSettingsId' && configs.length > 1) {
            const currentFormSelectedAdminSetting = props.adminSettingList.filter(x => !x.isArchive).find(x => x.id === value);
            for (let conf of configs) {
                const localAdminSetting = props.adminSettingList.find(x => x.id == conf.adminSettingsId)
                if(!!localAdminSetting && (localAdminSetting.isKeepEmployeeWorkRule !== currentFormSelectedAdminSetting.isKeepEmployeeWorkRule || localAdminSetting.autoApproval !== currentFormSelectedAdminSetting.autoApproval)) {
                    conf.adminSettingsId = null;
                }
            }
        }
        props.handleInputchange(configs)
    }

    const addClick = () => {
        let configs = [...props.configs, { isNew: true, enablePartialShifts: false }]
        props.handleInputchange(configs)
    }

    const removeClick = (i) => {
        let configs = [...props.configs];
        configs.splice(i, 1);
        props.handleInputchange(configs)
    }

    const createButton = () => {
        const { hideOnMax, configs, maxConfigs, isFullyEditable } = props
        if (hideOnMax && (configs.length >= maxConfigs || !isFullyEditable))
            return null
        return <Button disabled={configs.length >= maxConfigs || !isFullyEditable} variant="outlined" color="primary" onClick={addClick} startIcon={<AddIcon />}>Add Rule Set</Button>

    }

    const isDuplicate = (config) => props.configs.filter(x => x.hyperfindId === config.hyperfindId).length > 1;

    useEffect(() => {
        const { configs, setErrors } = props;
        //Check for errors
        const hasDuplicates = _.uniqBy(configs, x => x.hyperfindId).length !== configs.length;
        if (hasDuplicates) {
            setErrors(true);
        }

    }, [JSON.stringify(props.configs)])

    return (
        <React.Fragment >
            {createUI()}
            {createButton()}
        </React.Fragment>
    );
}

export default withTranslation('employmentBillboard')(DynamicHyperfindForm);